const discontinuedDrugList = [
  "Lantus 3 mL Cartridge 100 U/mL",
  "Lantus 10 mL Vial 100 U/mL",
  "Lantus SoloStar 100 U/mL"
];

export default discontinuedDrugList;
